import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'utils/i18n';
import translations from './translations';
import { StaticPageShell } from 'feSharedIndex';
import './FunIndex.css';

/**
 * FunIndex Component
 * Displays a grid of fun pages available in the fun section
 */
const FunIndex = () => {
  const { language } = useTranslation();
  const pageTranslations = translations[language] || translations.en;
  
  const t = (key, defaultValue = '') => {
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations);
    return value || defaultValue || key;
  };

  const funPages = [
    {
      id: 'wichteln',
      title: t('pages.wichteln.title', 'Wichteln'),
      description: t('pages.wichteln.description', 'Secret Santa name assigner'),
      path: '/fun/wichteln',
      icon: '🎁'
    }
  ];

  return (
    <StaticPageShell
      title={t('title', 'Fun Pages')}
      lead={t('subtitle', 'Enjoy our collection of fun and interactive pages')}
      contentClassName="fun-index-content"
    >
      <div className="fun-pages-grid">
        {funPages.map((page) => (
          <Link key={page.id} to={page.path} className="fun-page-card">
            <div className="fun-page-icon">{page.icon}</div>
            <h3 className="fun-page-title">{page.title}</h3>
            <p className="fun-page-description">{page.description}</p>
            <div className="fun-page-link">
              {t('pages.view', 'View Page')} →
            </div>
          </Link>
        ))}
      </div>
    </StaticPageShell>
  );
};

export default FunIndex;







